import { PromoCodeCreatedBy, PromoCodeTag } from '../../../../../../services/exports/Constants';

export default {
  title: 'Codici promo',
  tabs: {
    active: 'Attivo',
    expired: 'Scaduto',
    email_sign_up: 'Iscrizione email promo',
  },
  show_master_promo_code: 'Mostra il codice promo master ai clienti',
  send_rejected_order_apologies_promo_code:
    'Invia codice promo ai clienti quando un ordine viene rifiutato manualmente',
  filters: {
    tag: {
      placeholder: 'Tag',
      options: {
        [PromoCodeTag.Master]: 'Master',
        [PromoCodeTag.Campaign]: 'Campagna',
        [PromoCodeTag.OneTime]: 'Uso singolo',
      },
    },
    code: {
      placeholder: 'Codice',
    },
    campaign: {
      placeholder: 'Campagna',
    },
    created_by: {
      placeholder: 'Creato da',
      options: {
        [PromoCodeCreatedBy.User]: 'Utente',
        [PromoCodeCreatedBy.System]: 'Sistema',
      },
    },
  },
  fields: {
    code: 'Codice',
    tag: 'Tag',
    type: 'Tipo',
    discount_type: 'Tipo di sconto',
    discount: 'Sconto',
    usage_threshold: 'Soglia di utilizzo',
    quantity: 'Quantità',
    expires_at: 'Scadenza',
    level: 'Livello',
    max_discount: 'Sconto massimo',
    created_by: 'Creato da',
    image: 'Immagine',
  },
  tags: {
    [PromoCodeTag.Master]: 'Master',
    [PromoCodeTag.Campaign]: 'Campagna',
    [PromoCodeTag.OneTime]: 'Uso singolo',
  },
  types: {
    single_use: 'Uso singolo',
    multi_use: 'Uso multiplo',
    unknown: 'Sconosciuto',
  },
  discount_types: {
    fixed_amount: 'Importo fisso',
    percentage: 'Percentuale',
    unknown: 'Sconosciuto',
  },
  created_by: {
    [PromoCodeCreatedBy.User]: 'Utente',
    [PromoCodeCreatedBy.System]: 'Sistema',
  },
  labels: {
    discount: 'Sconto',
    usage_threshold: 'Soglia di utilizzo',
    company: 'Azienda',
    restaurant: 'Ristorante',
    restaurant_group: 'Marchio',
  },
  buttons: {
    add: 'Aggiungi',
    edit: 'Modifica',
    delete: 'Elimina',
    restore: 'Ripristina',
    add_promo_code: 'Aggiungi codice promo',
    images: 'Gestisci immagine',
  },
  toasts: {
    failed_to_load_data: 'Caricamento dati non riuscito',
    failed_to_save_settings: 'Salvataggio delle modifiche non riuscito',
    failed_to_delete_promo_code: 'Eliminazione del codice promo non riuscita',
    failed_to_restore_promo_code: 'Ripristino del codice promo non riuscito',
    promo_code_got_deleted: 'Codice promo eliminato',
    promo_code_got_restored: 'Codice promo ripristinato',
  },
  delete_confirmation: {
    title: 'Eliminare il codice promo?',
    buttons: {
      yes: 'Sì',
      no: 'No',
    },
  },
  restore_confirmation: {
    title: 'Ripristinare il codice promo?',
    buttons: {
      yes: 'Sì',
      no: 'No',
    },
  },
};
